//
//
//
//
//
//
//
//
//
//

export default {
  computed: {
    settings: function () {
      return this.$store.state.settings;
    },

    currentResultStart: function () {
      if (this.results.currentPage == 0) {
        return 1;
      } else {
        return this.results.currentPage * this.results.pageSize + 1;
      }
    },
    currentResultsEnd: function () {
      if (this.results.currentPage == 0) {
        if (this.results.totalResultCount <= this.results.pageSize) {
          return this.results.totalResultCount;
        } else {
          return this.results.pageSize;
        }
      } else {
        var max = (this.results.currentPage + 1) * this.results.pageSize + 1;
        if (max > this.results.totalResultCount) {
          return this.results.totalResultCount;
        } else {
          return max;
        }
      }
    },
    results: function () {
      return this.$store.state.results;
    },
  },
};
